import * as React from 'react';
import {
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   Blockquote,
   History,
   CustomMention,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
} from '../extensions';
import { Editor } from '@tiptap/react';
import { TiptapMenubar } from '../components/TiptapMenubar';
import { MenuSeparator } from '../components/MenuSeparator';
import {
   BoldButton,
   ItalicButton,
   CodeButton,
   LinkButton,
   BlockquoteButton,
   UndoButton,
   RedoButton,
} from '../components/buttons';

import type { TiptapExtension } from '../tiptap';

export const CommentsExtensions: Array<TiptapExtension> = [
   Document,
   Paragraph,
   Text,
   Bold,
   Italic,
   Strike,
   CustomCode,
   EditableLink,
   Blockquote,
   History,
   CustomMention,
   HardBreak,
   CustomSubscript,
   CustomSuperscript,
];

export const CommentsMenuBar = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapMenubar>
         <BoldButton editor={editor} />
         <ItalicButton editor={editor} />
         <CodeButton editor={editor} />
         <LinkButton editor={editor} />
         <BlockquoteButton editor={editor} />
         <MenuSeparator />
         <UndoButton editor={editor} />
         <RedoButton editor={editor} />
      </TiptapMenubar>
   );
};
